export const Editor = {
  Write: 'Write',
  Preview: 'Preview',
  UploadingImage: 'Uploading image',
  PasteDropSelect: 'Attach files by dragging & dropping, selecting or pasting them.',
};
